// GENERATED FILE — DO NOT EDIT MANUALLY
// Generated from: public/config/domains/application.registry.yml
// Run `npm run codegen` to regenerate

export enum ApplicationEvents {
  LOAD_APPLICATION = "load_application",
  LOAD_APPLICATIONS = "load_applications",
  CREATE_APPLICATION = "create_application",
  UPDATE_APPLICATION = "update_application",
  DELETE_APPLICATION = "delete_application",
  GET_APPLICATION_STATUS = "get_application_status",
  DEPLOY_APPLICATION = "deploy_application",
  APPLICATION_LOADED = "application_loaded",
  APPLICATIONS_LOADED = "applications_loaded",
  APPLICATION_CREATED = "application_created",
  APPLICATION_UPDATED = "application_updated",
  APPLICATION_DELETED = "application_deleted",
  APPLICATION_ERROR = "application_error",
  APPLICATION_STATUS_UPDATED = "application_status_updated",
  APPLICATION_DEPLOYED = "application_deployed",
  SYSTEM_PROVISIONED = "system_provisioned",
  SYSTEM_STOPPED = "system_stopped",
  SYSTEM_STARTED = "system_started",
  SYSTEM_CREATED = "system_created",
  SYSTEM_DELETED = "system_deleted",
  STACK_TEMPLATE_SELECTED = "stack_template_selected",
  CLEAR_APPLICATION_ERROR = "clear_application_error",
  PROVISION_SYSTEM = "provision_system",
  STOP_SYSTEM = "stop_system",
  START_SYSTEM = "start_system",
}

export enum ApplicationEndpoints {
  LIST_APPLICATIONS = "/api/v1/applications",
  LIST_SERVICE_BINDINGS = "/api/v1/applications/:alias/service-bindings",
  CREATE_SERVICE_BINDING = "/api/v1/applications/:alias/service-bindings",
  LIST_ORG_SERVICE_BINDINGS = "/api/v1/organizations/:alias/service-bindings",
  CREATE_ORG_SERVICE_BINDING = "/api/v1/organizations/:alias/service-bindings",
  GET_ORG_SERVICE_BINDING_CREDENTIALS = "/api/v1/organizations/:alias/service-bindings/:bindingId/credentials",
  ROTATE_ORG_SERVICE_BINDING = "/api/v1/organizations/:alias/service-bindings/:bindingId/rotate",
  REVOKE_ORG_SERVICE_BINDING = "/api/v1/organizations/:alias/service-bindings/:bindingId",
  ACTIVATE_CUSTOMER_IDENTITY = "/api/v1/organizations/:alias/identity/activate",
  GET_CUSTOMER_IDENTITY_STATUS = "/api/v1/organizations/:alias/identity/status",
  DEACTIVATE_CUSTOMER_IDENTITY = "/api/v1/organizations/:alias/identity/deactivate",
  LIST_IDENTITY_CLIENTS = "/api/v1/organizations/:alias/identity/clients",
  CREATE_IDENTITY_CLIENT = "/api/v1/organizations/:alias/identity/clients",
  GET_IDENTITY_CLIENT = "/api/v1/organizations/:alias/identity/clients/:clientId",
  GET_IDENTITY_CLIENT_CREDENTIALS = "/api/v1/organizations/:alias/identity/clients/:clientId/credentials",
  ROTATE_IDENTITY_CLIENT = "/api/v1/organizations/:alias/identity/clients/:clientId/rotate",
  REVOKE_IDENTITY_CLIENT = "/api/v1/organizations/:alias/identity/clients/:clientId",
  LIST_IDENTITY_USERS = "/api/v1/organizations/:alias/identity/users",
  CREATE_IDENTITY_USER = "/api/v1/organizations/:alias/identity/users",
  UPDATE_IDENTITY_USER = "/api/v1/organizations/:alias/identity/users/:userId",
  DELETE_IDENTITY_USER = "/api/v1/organizations/:alias/identity/users/:userId",
  LIST_IDENTITY_PROVIDERS = "/api/v1/organizations/:alias/identity/providers",
  ADD_IDENTITY_PROVIDER = "/api/v1/organizations/:alias/identity/providers",
  REMOVE_IDENTITY_PROVIDER = "/api/v1/organizations/:alias/identity/providers/:providerAlias",
  GET_APPLICATION = "/api/v1/applications/:id",
  CREATE_APPLICATION = "/api/v1/applications",
  UPDATE_APPLICATION = "/api/v1/applications/:id",
  DELETE_APPLICATION = "/api/v1/applications/:id",
  GET_APPLICATION_STATUS = "/api/v1/applications/:id/status",
  GET_APPLICATION_METRICS = "/api/v1/applications/:id/metrics",
  DEPLOY_APPLICATION = "/api/v1/applications/:id/deploy",
  DEPLOY_ONLY = "/api/v1/applications/:id/deploy-only",
  BUILD_APPLICATION = "/api/v1/applications/:id/build",
  BUILD_AND_DEPLOY = "/api/v1/applications/:id/build-and-deploy",
  LIST_STACK_TEMPLATES = "/api/v1/templates",
  GET_APPLICATION_PODS = "/api/v1/applications/:id/pods",
  GET_APPLICATION_EVENTS = "/api/v1/applications/:id/events",
  PAUSE_APPLICATION = "/api/v1/applications/:id/pause",
  RESUME_APPLICATION = "/api/v1/applications/:id/resume",
  SET_DELETE_PROTECTION = "/api/v1/applications/:id/delete-protection",
  GET_SYSTEM_BILLING = "/api/v1/applications/:id/billing",
  GET_ORG_BILLING = "/api/v1/billing/:id/summary",
  GET_PROJECT_BILLING = "/api/v1/projects/:id/billing",
  GET_BILLING_PLAN = "/api/v1/billing/plan",
  GET_BILLING_FORECAST = "/api/v1/billing/forecast",
  GET_PAYMENT_METHODS = "/api/v1/billing/payment-methods",
  ACTIVATE_BILLING = "/api/v1/billing/activate",
  GET_FIN_OPS_SUMMARY = "/api/v1/finops/summary",
  GET_FIN_OPS_BY_ENVIRONMENT = "/api/v1/finops/by-environment",
  GET_FIN_OPS_RECOMMENDATIONS = "/api/v1/finops/recommendations",
  RETRY_PROVISIONING = "/api/v1/applications/:id/retry-provisioning",
  RETRY_BUILD_APPLICATION = "/api/v1/applications/:id/retry-build",
  FORCE_FAIL_BUILD = "/api/v1/applications/:id/force-fail-build",
  GET_BUILD_LOGS = "/api/v1/applications/:id/build-logs",
  GET_SERVICE_LOGS = "/api/v1/applications/:id/services/:serviceName/logs",
  GET_APPLICATION_MANIFEST = "/api/v1/applications/:id/manifest",
  GET_APPLICATION_MANIFEST_PREVIEW = "/api/v1/applications/:id/manifest-preview",
  GET_APPLICATION_MANIFEST_VERSIONS = "/api/v1/applications/:id/manifest-versions",
  GET_APPLICATION_MANIFEST_DIFF = "/api/v1/applications/:id/manifest-diff",
}
